/** @format */

import React from "react";
import Gauge from "./Component/Gauge";
const App = () => {
  return (
    <>
      <Gauge percent="80" />
    </>
  );
};
export default App;
